import store from "../store";

const openModal = function(el, { value }) {
  el.addEventListener("click", function(e) {
    e.preventDefault();
    store.dispatch("showModal", value);
  });
};

const closeModal = function(el, { value }) {
  el.addEventListener("click", function(e) {
    e.preventDefault();
    store.dispatch("hideModal", value);
  });
};

export default { openModal, closeModal };
